import React, { useContext } from "react";
import styled from "styled-components";
import { AppContext } from "./AppProvider";

const PointsStyles = styled.div``;

function Points() {
  const ctx = useContext(AppContext);
  return (
    <div className="points">
      <div
        style={{
          width: "400px",
          height: "400px",
          background: "red",
          clipPath: ctx.points,
        }}
      ></div>
    </div>
  );
}

export default Points;
